﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';

import tpl_customSubscriptionList from './tpl/customSubscriptionList.html';
import View_CustomSubscriptionListItem from './customSubscriptionListItem';

export default Marionette.CollectionView.extend({
    tagName: 'customSubscriptionList',
    childViewContainer: '#customSubscriptionList',
    childView: View_CustomSubscriptionListItem,
    getTemplate: function () {
        return tpl_customSubscriptionList();
    },
    initialize: function () {
        this.app = this.options.app;
    },
    buildChildView: function(child, ChildViewClass, childViewOptions){
        var options = _.extend({model: child}, childViewOptions);
        options.app = this.app;
        options.localSetting = this.options.localSetting;
        var view = new ChildViewClass(options);
        return view;
    }
});
